import React from 'react';
import { Spin } from 'antd';
import { SplashContainer } from './styles';

const SplashScreen = (props) => {
  return (
    <SplashContainer>
      <Spin tip={props.title || 'กำลังโหลดข้อมูล'} />
    </SplashContainer>
  );
};

export default SplashScreen;
